import type { AriaDatapointType, DataPointEventType } from "owa-analytics-types";
import { lazyLogDatapoint } from "../lazyFunctions";
import { addStackTraceToEvent } from "owa-analytics-utils/lib/addStackTraceToEvent";
import { getAnalyticsAddon } from "owa-analytics-addons";

export function logDatapoint(datapoint: AriaDatapointType, overrideEventType?: DataPointEventType): Promise<void> {
    // Add original stack trace
    addStackTraceToEvent(datapoint.getOptions());
    
    // Enqueue into the rolling datapoint cache for ODS (if the addon is registered)
    const datapointsAddon = getAnalyticsAddon("DatapointsCachePush");
    if (datapointsAddon?.isRegistered) {
        datapointsAddon.executeWhenReady(datapoint.getEventName(), datapoint.getAllProperties().Status, datapoint.getAllProperties().E2ETimeElapsed);
    }
    
    return lazyLogDatapoint.importAndExecute(datapoint, overrideEventType);
}
